import { render, staticRenderFns } from "./gltd.vue?vue&type=template&id=4ca78ef9&scoped=true&"
import script from "./gltd.vue?vue&type=script&lang=js&"
export * from "./gltd.vue?vue&type=script&lang=js&"
import style0 from "./gltd.vue?vue&type=style&index=0&id=4ca78ef9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca78ef9",
  null
  
)

export default component.exports